module.exports = __webpack_public_path__ + "static/instagram-88f75abab0557a4fe2a2251c8706158f.png";